import { usePage } from '@inertiajs/vue3'

export const useFeature = (name) => usePage().props._features[name]
